import { Component, OnInit } from '@angular/core';
import { UrlParamsService } from '@app/core';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.scss'],
  standalone: false
})
export class ContactsListComponent implements OnInit {
  constructor(public urlParamsService: UrlParamsService) {}

  ngOnInit(): void {}
}
